import React from 'react';
import { Card, Row, Col } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';

import faf_ne from './imgs/faf-national-edition.png';

import faf_se from './imgs/faf-special-edition.png';

const { Meta } = Card;

const data = [
  {
    title: 'Online Play',
    subTitle: ' Family And Friends Special Edition',
    image: faf_se,
    url: 'https://elt.oup.com/student/fafspecialvietnam/?cc=vn&selLanguage=en',
  },
  {
    title: 'Online Play',
    subTitle: 'Family And Friends National Edition',
    image: faf_ne,
    url: 'https://elt.oup.com/student/fafnationalvietnam/?cc=vn&selLanguage=en',
  },
];

const renderCards = (item, index) => {
  return (
    <Col key={index} onClick={() => window.open(item.url, '_blank')}>
      <Card
        style={{ maxWidth: 300 }}
        cover={
          <img
            alt="example"
            src={item.image}
          // style={{ height: 214 }}
          />
        }
        actions={[
          <ShareAltOutlined key="play" />,
        ]}
      >
        <Meta
          // avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
          title={item.title}
          description={item.subTitle}
        />
      </Card>
    </Col>
  );
};

const GameEducation = props => {
  return (
    <Row gutter={[16, 16]}>
      {
        data.map(renderCards)
      }
    </Row>
  );
};

export default GameEducation;
